export default __webpack_public_path__ + "media/welli-insight.4587575dc654190c36d5a99cfc00196a.webp";